import { render, staticRenderFns } from "./cat-sub-fw-array.vue?vue&type=template&id=2903ebd2&scoped=true&"
import script from "./cat-sub-fw-array.ts?vue&type=script&lang=ts&"
export * from "./cat-sub-fw-array.ts?vue&type=script&lang=ts&"
import style0 from "./cat-sub-fw-array.scss?vue&type=style&index=0&id=2903ebd2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2903ebd2",
  null
  
)

export default component.exports